// extracted by mini-css-extract-plugin
module.exports = {"container":"TranslationView_container__M0fhJ"};